import React from "react";
import { Link } from "react-router-dom";

const AboutUs = () => {
  // brand colors
  const BROWN = "#5b3a29";
  const OLIVE = "#8a8f3a";
  const WHITE = "#ffffff";

  const section = {
    background: WHITE,
    color: BROWN,
    padding: "60px 20px",
    fontFamily: "Inter, system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial",
  };

  const container = {
    maxWidth: 1200,
    margin: "auto",
    display: "flex",
    gap: 32,
    alignItems: "center",
  };

  const left = {
    flex: 1,
    minWidth: 260,
  };

  const eyebrow = {
    display: "inline-block",
    background: OLIVE,
    color: WHITE,
    padding: "6px 12px",
    borderRadius: 20,
    fontSize: 14,
    fontWeight: 600,
    marginBottom: 16,
  };

  const title = {
    fontSize: 36,
    margin: "0 0 16px 0",
    color: BROWN,
    lineHeight: 1.05,
    fontWeight: 700,
  };

  const desc = {
    fontSize: 16,
    color: "#333",
    lineHeight: 1.8,
    marginBottom: 22,
  };

  const ctas = {
    display: "flex",
    gap: 12,
    flexWrap: "wrap",
  };

  const primaryBtn = {
    background: BROWN,
    color: WHITE,
    padding: "12px 18px",
    borderRadius: 8,
    textDecoration: "none",
    fontWeight: 700,
    border: "none",
    cursor: "pointer",
  };

  const ghostBtn = {
    background: "transparent",
    color: BROWN,
    padding: "12px 18px",
    borderRadius: 8,
    textDecoration: "none",
    fontWeight: 700,
    border: `2px solid ${OLIVE}`,
    cursor: "pointer",
  };

  const right = {
    width: 420,
    maxWidth: "40%",
    borderRadius: 12,
    overflow: "hidden",
  };

  const image = {
    width: "100%",
    display: "block",
  };

  // responsive CSS injected
  const responsive = `
    @media (max-width: 900px) {
      .about-container { flex-direction: column-reverse !important; gap: 20px !important; }
      .about-right { width: 100% !important; max-width: 100% !important; }
      .about-title { font-size: 28px !important; text-align: center !important; }
      .about-desc { text-align: center !important; }
      .about-eyebrow { margin-left: auto; margin-right: auto; display: inline-block; }
      .about-ctas { justify-content: center !important; }
    }
  `;

  return (
    <section style={section} aria-labelledby="about-title">
      <style>{responsive}</style>

      <div style={container} className="about-container">
        <div style={left} className="about-left">
          <div style={eyebrow} className="about-eyebrow">L’ARTISAN — Handmade & Antique</div>

          <h2 id="about-title" style={title} className="about-title">
            Timeless craft. Honest materials. Made by hand.
          </h2>

          <p style={desc} className="about-desc">
            At <strong>L’ARTISAN</strong> we celebrate the warmth and character of handmade woodwork.
            Each piece is crafted by skilled artisans — from reclaimed-wood accents to unique antiques and bespoke home décor.
            We blend traditional techniques with contemporary taste to create pieces that age beautifully in your home.
          </p>

          <div style={ctas} className="about-ctas">
            <Link to="/shop" style={primaryBtn}>Shop The Collection</Link>
            <Link to="/contact" style={ghostBtn}>Contact Us</Link>
          </div>
        </div>

        <div style={right} className="about-right">
          <img
            src="https://res.cloudinary.com/defcamc5x/image/upload/v1762089600/ybyvejhuq3t6qm2ggqlv.png"
            alt="L'artisan logo and craft"
            style={image}
          />
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
